import React from 'react';
import { Box } from '@mui/material';
import { GTStringPayload } from '../../redux/types';

type Props = {
  payload: GTStringPayload;
};

const GTStringScore: React.FC<Props> = ({ payload }: Props) => (
  <Box sx={{ minWidth: 0 }}>
    {payload.map((p, index) => (
      <Box
          // eslint-disable-next-line react/no-array-index-key
        key={index}
        sx={{
          whiteSpace: 'pre-wrap',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
        }}
      >
        <span style={p.caseSensitive ? { fontWeight: 500 } : undefined}>
          {p.text}
        </span>
        {` (${p.score})`}
      </Box>
    ))}
  </Box>
);

export default GTStringScore;
